import { ApiRoutes } from '@gr/core/api-routes';
import type {
  MarkPublishedRequestDto,
  PackageMediaDto,
  PublicationDto,
  PublicationPackageDto,
  RecordPublicationRequestDto,
  UpdatePublicationRequestDto,
} from '@gr/core/distribution/publishing/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class PublishingApi {
  constructor(private readonly http: HttpClient) {}

  due(blogId: string): Promise<OperationResult<PublicationDto[]>> {
    return this.http.get(ApiRoutes.publishing.due(blogId));
  }
  history(blogId: string, postId: string): Promise<OperationResult<PublicationDto[]>> {
    return this.http.get(ApiRoutes.posts.publications(blogId, postId));
  }
  record(blogId: string, postId: string, input: RecordPublicationRequestDto): Promise<OperationResult<PublicationDto[]>> {
    return this.http.post(ApiRoutes.posts.publications(blogId, postId), input);
  }
  get(blogId: string, publicationId: string): Promise<OperationResult<PublicationDto>> {
    return this.http.get(ApiRoutes.publishing.byId(blogId, publicationId));
  }
  package(blogId: string, publicationId: string): Promise<OperationResult<PublicationPackageDto>> {
    return this.http.get(ApiRoutes.publishing.package(blogId, publicationId));
  }
  zipUrl(blogId: string, publicationId: string): string {
    return ApiRoutes.publishing.packageZip(blogId, publicationId);
  }
  markPublished(blogId: string, publicationId: string, input: MarkPublishedRequestDto): Promise<OperationResult<PublicationDto>> {
    return this.http.post(ApiRoutes.publishing.published(blogId, publicationId), input);
  }
  // PUB-UC-9
  updatePublished(blogId: string, publicationId: string, input: UpdatePublicationRequestDto): Promise<OperationResult<PublicationDto>> {
    return this.http.patch(ApiRoutes.publishing.published(blogId, publicationId), input);
  }
  // PUB-UC-10
  deletePublished(blogId: string, publicationId: string): Promise<OperationResult<null>> {
    return this.http.delete(ApiRoutes.publishing.published(blogId, publicationId));
  }
  cancel(blogId: string, publicationId: string, note?: string): Promise<OperationResult<PublicationDto>> {
    return this.http.post(ApiRoutes.publishing.cancel(blogId, publicationId), note ? { note } : {});
  }
  /** PUB-UC-2: файлы пакета для Web Share API; трафик учитывает API, как при скачивании. */
  async packageFiles(media: readonly PackageMediaDto[]): Promise<OperationResult<File[] | null>> {
    const files: File[] = [];
    for (const item of media) {
      const blob = await this.http.blob(item.downloadPath);
      if (!blob.success || !blob.data) return { ...blob, data: null };
      files.push(new File([blob.data], item.fileName, { type: item.mimeType }));
    }
    return { success: true, data: files, messages: [] };
  }
}
